import React from 'react';
import { useState } from 'react'
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar.js';
import Footer from './components/Footer/Footer';
import Home from './components/Home';
import ForgotPassword from './components/Navbar/ForgotPassword';
import PrivacyPolicy from './components/PrivacyPolicy';
import PasswordReset from './components/Navbar/PasswordReset';
import SalonDetails from './components/SalonDetails';
import AppointmentList from './components/AppointmentList';
import Profile from './components/Profile.js';
import Favourites from './components/Favourites.js';
import AdminSignIn from './components/Admin/AdminSignIn';
import AdminDashboard from './components/Admin/AdminDashboard.js';
import Dashboard from './components/Dashboard.js';
import SalonSearchBar from './components/SalonSearchBar';
// import GrokHome from './components/GrokHome.js';
import SpLogin from './components/SpLogin.js';
import Landing from './components/Landing.js';
import Carousel from './components/Carousel/MyCarousel.js';
import OwnersTerms from './components/OwnersTerms.js';
import ClientsTerms from './components/ClientsTerms.js';
import AboutUs from './components/AboutUs.js';
import Contact from './components/Contact.js';
import AdminReports from './components/Admin/AdminReports.js';


import { useJsApiLoader } from '@react-google-maps/api';

function App() {
  const [userId, setUserId] = useState(0)
  const [userName, setUserName] = useState('')
  const [userEmail, setUserEmail] = useState('')
  const [userMobile, setUserMobile] = useState('')
  const [user, setUser] = useState({})
  const [client, setClient] = useState(true)
  const [visible, setVisible] = useState(false)
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [loggedIn, setLoggedIn] = useState(false);
  const [spLoggedIn, setSpLoggedIn] = useState(false)
  const [spId, setSpId] = useState()
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "YOUR_FALLBACK_KEY",
    libraries: ["places", "maps"], // Consistent libraries
  });

  const spLoginRef = React.useRef(null);
  const landingRef = React.useRef(null);

  if (loadError) return <p>Error loading maps: {loadError.message}</p>
  if (!isLoaded) return <p>Loading maps…</p>

  const handleSelectSalon = (salon) => {
  };



  const handleScrollToLogin = () => {
    console.log("Scroll function called!")
    const yOffset = -100; // adjust for header height or tweak as needed
    const element = spLoginRef.current;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const handleScrollToLanding = () => {
    console.log("Scroll function called!")
    const yOffset = -100; // adjust for header height or tweak as needed
    const element2 = landingRef.current;
    const y = element2.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <Router>
      {client && <Navbar user={user} setUser={setUser} visible={visible} setVisible={setVisible} loggedIn={loggedIn} setLoggedIn={setLoggedIn} />}
      {client && <SalonSearchBar visible={visible} setVisible={setVisible} onSelectSalon={handleSelectSalon} />}

      <Switch>
        <Route exact path="/">
          <>
            <div ref={spLoginRef}>
              {!loggedIn && <SpLogin
                spLoggedIn={spLoggedIn}
                setSpLoggedIn={setSpLoggedIn}
                client={client}
                setClient={setClient}
                // setClient={setClient}
                spId={spId}
                setSpId={setSpId}
              />}
            </div>
            <Carousel />
            <Home
              // isLoaded={isLoaded}
              // client={client}
              // setClient={setClient}
              // loggedIn={loggedIn}
              // setLoggedIn={setLoggedIn}
              onScrollToLogin={handleScrollToLogin}
              onScrollToLanding={handleScrollToLanding}
            />
            {/* <div style={{ height: "10vh" }}></div> */}
            <div ref={spLoginRef}>
              {!loggedIn && <SpLogin
                spLoggedIn={spLoggedIn}
                setSpLoggedIn={setSpLoggedIn}
                client={client}
                setClient={setClient}
                // setClient={setClient}
                spId={spId}
                setSpId={setSpId}
              />}
            </div>
            <div ref={landingRef}>
              <Landing
                user={user}
                userId={userId}
                userName={userName}
                userEmail={userEmail}
                userMobile={userMobile}
              />
            </div>
          </>
        </Route>
        <Route exact path="/admin/login" component={AdminSignIn} />
        <Route exact path='/ForgotPassword' component={ForgotPassword} />
        <Route exact path='/OwnersTerms' component={OwnersTerms} />
        <Route exact path='/ClientsTerms' component={ClientsTerms} />
        <Route exact path='/PrivacyPolicy' component={PrivacyPolicy} />
        <Route exact path='/PasswordReset' component={PasswordReset} />
        <Route exact path='/AboutUs' component={AboutUs} />
        <Route exact path='/Contact' component={Contact} />
        <Route exact path='/dashboard' render={(props) => (<Dashboard {...props}
          client={client} setClient={setClient}
          visible={visible} setVisible={setVisible}
          spLoggedIn={spLoggedIn} setSpLoggedIn={setSpLoggedIn}
          spId={spId} setSpId={setSpId} />)}
        />
        <Route path="/salon/:id" component={SalonDetails} />
        <Route
          path="/appointments"
          render={(props) => (
            <AppointmentList
              {...props}
              visible={visible}
              setVisible={setVisible}
            />
          )}
        />
        <Route path="/profile" render={(props) => (
          <Profile
            {...props}
            visible={visible}
            setVisible={setVisible}
          />
        )} />
        <Route path="/favourites" render={(props) => (
          <Favourites
            {...props}
            visible={visible}
            setVisible={setVisible}
          />
        )} />
        <Route path="/admin" component={AdminDashboard} />
        {/* <Route path="/admin" component={AdminReports} /> */}
      </Switch>
      <Footer />

    </Router>
  );
}

export default App;
